export default "__VITE_ASSET__BIvFocub__"